<template>
  <div class="jump-useraddress nav-bar-fixed" style>
    <van-nav-bar title="新增收货地址" left-arrow fixed @click-left="back" />
    <van-field v-model="shr" required label="收货人" placeholder="请输入收货人姓名或昵称" />
    <van-field
      v-model="addressPCS"
      required
      readonly
      label="收货地址"
      placeholder="请选择省/市/区"
      @focus="showPop"
    />
    <van-field v-model="address" required label="详细地址" placeholder="街道小区楼牌房间号等信息" />
    <van-field v-model="phone" required label="手机号" placeholder="请输入11位手机号码" />
    <van-field v-model="bm" label="邮政编码" placeholder="请输入6位邮政编码" />
    <van-cell title="设置为默认收货地址">
      <van-switch v-model="isTrueAddress" />
    </van-cell>
    <van-button size="large" @click="save">提 交</van-button>

    <van-popup v-model="popShow" position="bottom" :overlay="true">
      <van-picker
        :columns="columns"
        show-toolbar
        value-key="areaName"
        @cancel="onPickerCancel"
        @confirm="onPickerConfirm"
        @change="onPickerChange"
      />
    </van-popup>
  </div>
</template>
<script>
import {
  NavBar,
  Row,
  Col,
  Field,
  Button,
  Popup,
  Picker,
  AddressEdit,
  Cell,
  Switch
} from "vant";

var citys = [];
var country = {};
var xjq = {};

export default {
  name: "useraddressadd",
  components: {
    [Cell.name]: Cell,
    [Switch.name]: Switch,
    [NavBar.name]: NavBar,
    [Row.name]: Row,
    [Col.name]: Col,
    [Field.name]: Field,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [AddressEdit.name]: AddressEdit,
    [Picker.name]: Picker
  },
  data() {
    return {
      isTrueAddress: true,
      popShow: false,
      columns: [
        {
          values: citys,
          className: "column1",
          defaultIndex: 0
        },
        {
          values: country["北京市"],
          className: "column2",
          defaultIndex: 1
        },
        {
          values: xjq["北京市"],
          className: "column3",
          defaultIndex: 2
        }
      ],
      addressPCS: "",
      addId: "",
      shr: "",
      address: "",
      phone: "",
      bm: "",
      num: 0
    };
  },
  mounted: function() {
    let that = this;
    that.getAreaList();
  },
  methods: {
    showPop() {
      this.popShow = true;
    },
    onPickerCancel() {
      this.popShow = false;
    },
    onPickerConfirm(values) {
      this.addressPCS =
        values[0].areaName +
        " " +
        values[1].areaName +
        " " +
        values[2].areaName;
      this.addId = values[2].id;
      this.popShow = false;
    },
    onPickerChange(picker, values, defaultIndex) {
      let ss;
      let that = this;
      if (defaultIndex == 0) {
        that.$api.post(
          that.jumuc.userCenter.areaList,
          { parent_id: values[0].id },
          successRes => {
            ss = successRes.data[0].areaName;
            country[values[0].areaName] = successRes.data;
            that.$api.post(
              that.jumuc.userCenter.areaList,
              { parent_id: successRes.data[0].id },
              successRes => {
                xjq[ss] = successRes.data;
                that.columns = [
                  {
                    values: citys,
                    className: "column1",
                    defaultIndex: 0
                  },
                  {
                    values: country[values[0].areaName],
                    className: "column2",
                    defaultIndex: 1
                  },
                  {
                    values: xjq[ss],
                    className: "column3",
                    defaultIndex: 2
                  }
                ];
                picker.setColumnValues(1, country[values[0].areaName]);
                picker.setColumnValues(2, xjq[values[1].areaName]);
              }
            );
          }
        );
      }
      if (defaultIndex == 1) {
        that.$api.post(
          that.jumuc.userCenter.areaList,
          { parent_id: values[1].id },
          successRes => {
            xjq[ss] = successRes.data;
            that.columns = [
              {
                values: citys,
                className: "column1",
                defaultIndex: 0
              },
              {
                values: country[values[0].areaName],
                className: "column2",
                defaultIndex: 1
              },
              {
                values: xjq[ss],
                className: "column3",
                defaultIndex: 2
              }
            ];
            picker.setColumnValues(2, xjq[values[1].areaName]);
          }
        );
      }
      // picker.setColumnValues(1, citys[values[0]]);
    },
    getAreaList(id) {
      let that = this;
      let aa;
      let ss;
      //省
      that.$api.post(
        that.jumuc.userCenter.areaList,
        { parent_id: id },
        successRes => {
          citys = successRes.data;
          aa = successRes.data[0].areaName;
          //市
          that.$api.post(
            that.jumuc.userCenter.areaList,
            { parent_id: citys[0].id },
            successRes => {
              country[citys[0].areaName] = successRes.data;
              ss = successRes.data[0].areaName;
              //县/区
              that.$api.post(
                that.jumuc.userCenter.areaList,
                { parent_id: successRes.data[0].id },
                successRes => {
                  xjq[ss] = successRes.data;
                  that.columns = [
                    {
                      values: citys,
                      className: "column1",
                      defaultIndex: 0
                    },
                    {
                      values: country[aa],
                      className: "column2",
                      defaultIndex: 1
                    },
                    {
                      values: xjq[ss],
                      className: "column3",
                      defaultIndex: 2
                    }
                  ];
                }
              );
            }
          );
        }
      );
    },
    back() {
      history.back();
    },
    save() {
      let that = this;
      that.$api.post(
        that.jumuc.userCenter.addressSave,
        {
          trueName: that.shr,
          areaId: that.addId,
          areaInfo: that.address,
          mobile: that.phone,
          zip: that.bm,
          defaultFlag: that.isTrueAddress == true ? 1 : 0
        },
        successRes => {
          if (successRes.success) {
               history.back(-1);
            // that.$router.push({
            //     path: '/user/address'
            // })
          } else {
            that.$toast(successRes.msg);
          }
        }
      );
    }
  }
};
</script>
<style lang="less">
body {
  background: #f7f7ff;
}

@bule-thame: #3c6eeb;
.jump-useraddress {
  button.van-button {
    background-color: @bule-thame;
    color: white;
    font-weight: 700;
    border-radius: 5px;
    margin: 25px 0 10px;
  }
}
</style>

